import { azLocalDigits, formatAzLocal } from "../lib/phone";

/* Telefon xanası: solda sabit «+994», sağda 9 rəqəm (təsisçi qərarı,
   2026-10-21). `value` yerli rəqəmlərdir (məs. "558855522"); `onChange`
   normallaşdırılmış rəqəmləri verir — yapışdırılan tam nömrə də özü düzəlir. */
export const PhoneInput = ({ value, onChange, testid, placeholder = "55 885 55 22", ...rest }) => (
  <div className="flex items-stretch border border-brand-line bg-white focus-within:border-brand-ink transition-colors">
    <span className="flex items-center px-3 text-sm text-brand-sub border-r border-brand-line select-none" aria-hidden="true">
      +994
    </span>
    <input
      type="tel"
      inputMode="numeric"
      autoComplete="tel-national"
      className="flex-1 min-w-0 px-3 py-3 text-sm outline-none bg-transparent"
      value={formatAzLocal(value || "")}
      onChange={(e) => onChange(azLocalDigits(e.target.value))}
      placeholder={placeholder}
      maxLength={24}   /* «+994 (55) 885-55-22» kimi yapışdırma 16-dan uzundur; rəqəmləri azLocalDigits özü kəsir */
      aria-label={`+994 ${placeholder}`}
      data-testid={testid}
      {...rest}
    />
  </div>
);
